<template>
  <div class="text-input">
    <label><b>{{label}}</b></label>
    <div class="input-group">
      <input 
        type='text' 
        :class="calculateClass()" 
        :disabled="disabled" 
        v-model="displayValue" 
        @change="$emit('change', isPercent)"
        @focus="focusEvent" 
        @blur="blurEvent" 
        :aria-label="{label}">
    </div>
    <div v-if="validator && validator.$error && validator.$dirty">
         <div class="error" v-for="(key, index) in Object.keys(validator.$params)" :key="key + index" >
           <div class="p-0 m-0" v-if="!validator[key]">{{ validatorMsgMap[key] }}</div>
         </div>
      </div>
  </div>
    <!-- <input type="text" v-model="displayValue" @blur="isInputActive = false" @focus="isInputActive = true"/> -->
</template>
<script>
export default {
  name: "CurrencyInputWithPercentAllowed",
  props: {
     label: {
        type: String,
     },
     placeholder: {
        type: String,
     },
     disabled: {
        type: Boolean,
        default: false,
     },
     value: {
        type: [String, Number],
     },
     subtotal: {
       type: [String, Number],
       default: 0
     },
     customStyles: {
         type: Object,
     },
     validatorMsgMap: {
         type: Object,
         default: null,
     },
     validator: {
         type: Object,
         default: null,
     }
  },
  data(){
    return{
      updating: false,
      isPercent: false,
    }
  },
  methods: {
    blurEvent(){
      this.updating=false;
      this.$emit('blur');
    },
    focusEvent(){
      this.updating = true;
      this.$emit('focus');
    },
    calculateClass() {
			return this.value < 0 ? 'form-control negative-value' : 'form-control';
		}
  },
  computed: {
    displayValue: {
        get: function() {
            if (this.updating) {
                // Cursor is inside the input field. unformat display value for user
                if(this.value === null || this.value === undefined) return 0
                return this.value.toString()
            } else {
                // User is not modifying now. Format display value for user interface
                if (this.value === null || this.value === undefined) return '$0.00'
                const workingValue = (typeof this.value === 'string') ? parseFloat(this.value) : this.value
								const baseValue = workingValue.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
								return `$${baseValue}`;
            }
        },
        set: function(modifiedValue) {
            // Recalculate value after ignoring "$" and "," in user input
            let containsPercent = modifiedValue.includes('%')
            let newValue = parseFloat(modifiedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ""));
            // Ensure that it is not NaN
            this.isPercent = false;
            if(containsPercent){
              this.isPercent = true;
              this.$emit('percentageInput', newValue);
              newValue = (this.subtotal * ( newValue / 100 )).toFixed(2);
            }
            if (isNaN(newValue)) {
                newValue = 0
            }
            // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
            // $emit the event so that parent component gets it
            this.$emit('input', newValue);
        }
    }
  }
}

</script>


<style scoped>
  .error {
      color: red;
      font-size: .7em;
      padding: 2px;
   }

	 .negative-value {
		 color: red;
	 }
</style>